// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2VekH","dragIcon":"Choice_dragIcon__gnvOL","left":"Choice_left__33I84","input":"Choice_input__1FBys"};